/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

import axios from "axios"
import AuthService from "./service/auth.service";
import crypto from 'crypto'
import {BaseUrl} from "./service/base.url";
import {setGlobalStatus} from "./context/exchange.context";
import {setIsUserActive} from "./context/auth.context";

const authSVC = new AuthService()

function md5(txt){
    return crypto.createHash('md5').update(txt).digest('hex');
}

axios.defaults.baseURL = BaseUrl


const interceptConfig = async (config)=>{
  if(config.ignore){
    return config
  }
      if(config.totalTries){
            config.totalTries++
        } else {
            config.totalTries = 1
        }

        config.headers['x-tactics'] = md5((new Date()).toISOString().split('T')[0]);


        if(config.url.indexOf("/v1/user") >= 0 && !config.authorized){
            return config
        }

        let token
        if (authSVC.hasToken()) {
            token = authSVC.getToken()
            config.headers['Authorization'] = 'Bearer ' + token;
        }

        return config;
}

const InitInterceptors = ()=>{
    axios.interceptors.request.use(
        interceptConfig
    )

    axios.interceptors.response.use( (resp) =>{
        if(resp.headers?.['x-user-status']?.length){
            setIsUserActive(resp.headers['x-user-status'] == "1")
        }
        return resp
    }, async (err) =>{
        let response = err?.response
        let config = err?.config
        let totalTries = err?.config?.totalTries
        let status = response?.status
        let isIncorrectKey = status == 400 && (
            response?.data?.error?.Message?.includes?.("incorrect key") ||
            response?.data?.error?.Message?.includes?.("pub-key-")
        )

        if(status == 401){
            authSVC.removeToken()
        }

        if(isIncorrectKey && !config?.retried){
            authSVC.clearPublicKeys()
            config.retried = true;
            config.data = config.originalData;
            delete config.ignore;
            config.encrypt = true
            return axios.request(config);
        }

        // if(config?.maxRetries && totalTries <= (config.maxRetries + 1)) {
        //
        //     return new Promise((resolve, reject)=>{
        //
        //       setTimeout(()=>{
        //         return axios.request(config).then(resolve).catch(reject)
        //       }, 3000)
        //     })
        // }

        return err
    })
}

export default InitInterceptors
